export default "__VITE_ASSET__25a95523__"